/**
 * Works with the <SocialButton /> component among others
 */
export interface ISocialPage {
  name: typeof SocialMediaAccountName[number];
  readonly pageUrl: string;
}

export const SocialMediaAccountName = <const>["Facebook-Profile", "Facebook-Page", "Twitter", "Instagram", "TikTok", "Youtube-Channel", "LinkedIn-Company", "LinkedIn-Profile"];
export type SocialMediaAccounts = {
  [key in typeof SocialMediaAccountName[number]]: ISocialPage
}

export class FacebookPage implements ISocialPage {
  constructor(private handle: string) {
  }
  name: typeof SocialMediaAccountName[number] = "Facebook-Page";
  get pageUrl() {
    return `https://www.facebook.com/pg/${this.handle}`;
  }
}

export class FacebookProfile implements ISocialPage {
  constructor(private handle: string) {
  }
  name: typeof SocialMediaAccountName[number] = "Facebook-Profile";
  get pageUrl() {
    return `https://www.facebook.com/${this.handle}`;
  }
}

export class TwitterPage implements ISocialPage {
  constructor(private handle: string) {
  }
  name: typeof SocialMediaAccountName[number] = "Twitter";
  get pageUrl() {
    return `https://twitter.com/${this.handle}`;
  }
}

export class LinkedInProfile implements ISocialPage {
  constructor(private handle: string) {
  }
  name: typeof SocialMediaAccountName[number] = "LinkedIn-Profile";
  get pageUrl() {
    return `https://www.linkedin.com/${this.handle}`;
  }
}

export class LinkedInCompany implements ISocialPage {
  constructor(private handle: string) {
  }
  name: typeof SocialMediaAccountName[number] = "LinkedIn-Company";
  get pageUrl() {
    return `https://www.linkedin.com/company/${this.handle}`;
  }
}


export class YoutubeChannel implements ISocialPage {
  constructor(private channelId: string) {
  }
  name: typeof SocialMediaAccountName[number] = "Youtube-Channel";
  get pageUrl() {
    return `https://www.youtube.com/channel/${this.channelId}`;
  }
}

export class InstagramPage implements ISocialPage {
  constructor(private handle: string) {
  }
  name: typeof SocialMediaAccountName[number] = "Instagram";
  get pageUrl() {
    return `https://www.instagram.com/${this.handle}`;
  }
}
